import httpClient from "../utilis/jwtRequest";

const REEGIONS_URL = "/Regions/";

function getAllRegions() {
  return httpClient.get(REEGIONS_URL);
}

export const regionsService = {
  getAllRegions: getAllRegions,
};

